const NUM_LINK = 1;
const NUM_CHECKOUT = 2;
const NUM_DOWNLOAD = 3;

export default {
  NUM_LINK,
  NUM_CHECKOUT,
  NUM_DOWNLOAD
};
